export const baremetrics = {
    name: 'Baremetrics',
    key: 'baremetrics',
    assets: {
        icon: '/images/competitors/baremetrics.svg',
    },
    products: {
        revenue_analytics: {
            available: true,
            features: {
                revenue_tracking: true,
                event_based_revenue_tracking: true,
                native_multi_source_revenue_tracking: true,
                deferred_revenue: true,
                product_analytics_integration: false,
                multi_currency_support: true,
                revenue_prediction: true,
                sql_access: false,
            },
        },
    },
    platform: {
        deployment: {
            eu_hosting: false,
            managed_reverse_proxy: false,
            open_source: false,
            self_host: false,
        },
        pricing: {
            free_tier: false,
            transparent_pricing: false,
            usage_based_pricing: true,
        },
        developer: {
            api: false,
            collaboration: false,
            mobile_sdks: false,
            native_data_sources: false,
            proxies: false,
            sdks: false,
            server_side_sdks: false,
            sql: false,
        },
        tools: {
            cms: '',
            notebooks: false,
            project_management_tools: '',
        },
        integrations: {
            azure_blob: false,
            bigquery: false,
            cdp: false,
            ci_cd_integrations: false,
            community_integrations: false,
            csv_exports: false,
            customer_io: false,
            data_warehouse: false,
            datadog: false,
            email_reports: false,
            exports: false,
            gcs: false,
            google_ads: false,
            hubspot: false,
            imports: false,
            intercom: false,
            microsoft_teams: false,
            redshift: false,
            rudderstack: false,
            s3: false,
            salesforce: false,
            segment: false,
            sentry: false,
            slack: false,
            snowflake: false,
            stripe: false,
            warehouse_import: false,
            wordpress: false,
            zapier: false,
            zendesk: false,
        },
        security: {
            bot_blocking: false,
            cookieless_tracking: false,
            data_anonymization: false,
            data_retention: false,
            gdpr_ready: false,
            hipaa_ready: false,
            history_audit_logs: false,
            reverse_proxy: false,
            saml_sso: false,
            soc2_certified: false,
            two_factor_auth: false,
            user_privacy_options: false,
        },
        analytics_integration: {
            built_in_analytics: false,
        },
    },
    pricing: {
        model: 'Seat-based',
    },
}
